module.exports = __webpack_public_path__ + "static/media/E_SDG_Icons-7.b2c269a8.jpg";